/* Wonder Pencil — theme script (vanilla, no dependencies) */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const WP = window.WP || { routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', recs: '/recommendations/products', search: '/search/suggest' }, moneyFormat: '${{amount}}' };
  const root = (WP.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- money ---------- */
  function money(cents) {
    const fmt = WP.moneyFormat || '${{amount}}';
    const n = Number(cents) / 100;
    const withDelims = (num, dec, t = ',', d = '.') => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(d);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return withDelims(n, 0);
        case 'amount_with_comma_separator': return withDelims(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(n, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(n, 2, ' ', ',');
        default: return withDelims(n, 2);
      }
    });
  }
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const cleanVariant = (t) => String(t || '').replace(/\s*\/\s*China Mainland/i, '').replace(/^Default Title$/, '').replace(/Sytel/g, 'Style').replace(/^(\d{1,2})$/, 'Design $1');

  /* ---------- header ---------- */
  const header = $('[data-wp-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    // mega menu
    $$('[data-wp-mega-toggle]', header).forEach(btn => {
      const panel = document.getElementById(btn.getAttribute('aria-controls'));
      const item = btn.closest('.wp-nav__item');
      let t;
      const open = () => { clearTimeout(t); $$('[data-wp-mega-toggle][aria-expanded="true"]').forEach(b => b !== btn && close(b)); btn.setAttribute('aria-expanded', 'true'); panel.hidden = false; };
      const close = (b = btn) => { b.setAttribute('aria-expanded', 'false'); document.getElementById(b.getAttribute('aria-controls')).hidden = true; };
      btn.addEventListener('click', () => btn.getAttribute('aria-expanded') === 'true' ? close() : open());
      if (window.matchMedia('(hover: hover)').matches) {
        item.addEventListener('mouseenter', open);
        item.addEventListener('mouseleave', () => { t = setTimeout(() => close(), 180); });
      }
      document.addEventListener('keydown', e => { if (e.key === 'Escape' && btn.getAttribute('aria-expanded') === 'true') { close(); btn.focus(); } });
      document.addEventListener('click', e => { if (!item.contains(e.target)) close(); });
    });
    // search
    const search = $('[data-wp-search]'), input = $('[data-wp-search-input]'), results = $('[data-wp-search-results]');
    const openSearch = () => { search.hidden = false; input.focus(); };
    const closeSearch = () => { search.hidden = true; };
    $$('[data-wp-search-open]').forEach(b => b.addEventListener('click', () => search.hidden ? openSearch() : closeSearch()));
    $$('[data-wp-search-close]').forEach(b => b.addEventListener('click', closeSearch));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && search && !search.hidden) closeSearch(); });
    let st;
    input && input.addEventListener('input', () => {
      clearTimeout(st);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      st = setTimeout(async () => {
        try {
          const r = await fetch(`${WP.routes.search}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
          const d = await r.json();
          const ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          results.innerHTML = ps.length ? `<ul>${ps.map(p => `<li><a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" width="52" height="52" loading="lazy">` : ''}<span>${esc(p.title)}</span><span class="wp-price">${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ''}</span></a></li>`).join('')}</ul>` : `<p>No matches yet. Press Enter to search everything.</p>`;
        } catch (e) { results.innerHTML = ''; }
      }, 220);
    });
  }
  // mobile nav
  const mnav = $('[data-wp-mnav]');
  if (mnav) {
    const burger = $('[data-wp-menu-open]');
    const open = () => { mnav.hidden = false; document.documentElement.classList.add('wp-lock'); burger.setAttribute('aria-expanded', 'true'); $('.wp-mnav__panel button', mnav).focus(); };
    const close = () => { mnav.hidden = true; document.documentElement.classList.remove('wp-lock'); burger.setAttribute('aria-expanded', 'false'); burger.focus(); };
    burger && burger.addEventListener('click', open);
    $$('[data-wp-menu-close]', mnav).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !mnav.hidden) close(); });
  }
  // announcement rotation (small screens show one at a time)
  $$('[data-wp-announce]').forEach(a => {
    const items = $$('.wp-announce__item', a); if (!items.length) return;
    let i = 0; items[0].classList.add('is-on');
    if (items.length > 1 && !reduce) setInterval(() => { items[i].classList.remove('is-on'); i = (i + 1) % items.length; items[i].classList.add('is-on'); }, 4500);
  });

  /* ---------- reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver((ents) => {
    ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
  $$('[data-wp-reveal],[data-wp-draw-on-view]').forEach(el => io ? io.observe(el) : el.classList.add('is-in'));

  /* ---------- hero parallax ---------- */
  $$('[data-wp-parallax]').forEach(stage => {
    if (reduce || !window.matchMedia('(pointer: fine)').matches) return;
    const layers = $$('[data-depth]', stage);
    let tx = 0, ty = 0, cx = 0, cy = 0, raf = null;
    const hero = stage.closest('[data-wp-hero]') || stage;
    hero.addEventListener('pointermove', e => {
      const r = hero.getBoundingClientRect();
      tx = (e.clientX - r.left) / r.width - 0.5; ty = (e.clientY - r.top) / r.height - 0.5;
      if (!raf) raf = requestAnimationFrame(tick);
    });
    hero.addEventListener('pointerleave', () => { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(tick); });
    function tick() {
      cx += (tx - cx) * 0.08; cy += (ty - cy) * 0.08;
      layers.forEach(l => { const d = parseFloat(l.dataset.depth) || 0.3; l.style.transform = `translate3d(${(-cx * 28 * d).toFixed(2)}px, ${(-cy * 22 * d).toFixed(2)}px, 0)`; });
      raf = (Math.abs(tx - cx) > 0.001 || Math.abs(ty - cy) > 0.001) ? requestAnimationFrame(tick) : null;
    }
  });

  /* ---------- coloring studio ---------- */
  $$('[data-wp-studio]').forEach(studio => {
    const art = $('[data-wp-art]', studio); if (!art) return;
    const regions = $$('.wp-r', art);
    const swatches = $$('.wp-swatch', studio);
    const meter = $('[data-wp-studio-meter]', studio);
    let color = swatches[0] ? swatches[0].dataset.color : '#F5B82E';
    const history = [];
    const filled = new Set();
    const key = 'wp-studio-v1';
    const setColor = (sw) => { swatches.forEach(s => s.setAttribute('aria-checked', String(s === sw))); color = sw.dataset.color; };
    swatches.forEach((sw, i) => {
      sw.addEventListener('click', () => setColor(sw));
      sw.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); const n = swatches[(i + (e.key === 'ArrowRight' ? 1 : -1) + swatches.length) % swatches.length]; setColor(n); n.focus(); }
      });
    });
    const update = () => {
      const pct = Math.min(1, filled.size / Math.max(8, Math.round(regions.length * 0.6)));
      if (meter) meter.style.width = (pct * 100).toFixed(0) + '%';
      studio.classList.toggle('is-active', filled.size >= 3);
      studio.classList.toggle('is-done', pct >= 1);
      try { localStorage.setItem(key, JSON.stringify(regions.map(r => r.style.fill || ''))); } catch (e) {}
    };
    const paint = (r, c, record = true) => {
      if (record) history.push([r, r.style.fill || '']);
      r.style.fill = c;
      if (c) filled.add(r); else filled.delete(r);
      if (!reduce) { r.classList.remove('is-pop'); void r.getBBox(); r.classList.add('is-pop'); }
    };
    regions.forEach(r => {
      r.addEventListener('click', () => { paint(r, color); update(); });
      r.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); paint(r, color); update(); } });
    });
    try { const saved = JSON.parse(localStorage.getItem(key) || 'null'); if (saved && saved.length === regions.length) { saved.forEach((c, i) => c && paint(regions[i], c, false)); update(); } } catch (e) {}
    const btn = (s) => $(s, studio);
    btn('[data-wp-studio-undo]') && btn('[data-wp-studio-undo]').addEventListener('click', () => { const h = history.pop(); if (h) { paint(h[0], h[1], false); update(); } });
    btn('[data-wp-studio-reset]') && btn('[data-wp-studio-reset]').addEventListener('click', () => { regions.forEach(r => paint(r, '', true)); update(); });
    btn('[data-wp-studio-random]') && btn('[data-wp-studio-random]').addEventListener('click', () => {
      const cols = swatches.map(s => s.dataset.color);
      regions.forEach((r, i) => setTimeout(() => { paint(r, cols[Math.floor(Math.random() * cols.length)]); if (i === regions.length - 1) update(); }, reduce ? 0 : i * 28));
    });
    btn('[data-wp-studio-save]') && btn('[data-wp-studio-save]').addEventListener('click', () => {
      const clone = art.cloneNode(true);
      clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
      $$('.wp-r', clone).forEach((r, i) => { r.setAttribute('fill', regions[i].style.fill || '#ffffff'); r.setAttribute('stroke', '#1F1C44'); r.setAttribute('stroke-width', '3'); r.setAttribute('stroke-linejoin', 'round'); });
      const svgStr = new XMLSerializer().serializeToString(clone);
      const img = new Image();
      img.onload = () => {
        const c = document.createElement('canvas'); c.width = 1200; c.height = 1040;
        const g = c.getContext('2d'); g.fillStyle = '#FFFDF8'; g.fillRect(0, 0, c.width, c.height);
        g.drawImage(img, 0, 0, 1200, 960);
        g.fillStyle = '#1F1C44'; g.font = '600 30px "WP Hand", cursive'; g.fillText('made with Wonder Pencil  ✦', 40, 1010);
        c.toBlob(b => { const a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = 'my-wonder-pencil-picture.png'; document.body.appendChild(a); a.click(); a.remove(); setTimeout(() => URL.revokeObjectURL(a.href), 2000); });
      };
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svgStr);
    });
  });

  /* ---------- line story: a pencil draws down the page ---------- */
  $$('[data-wp-line]').forEach(sec => {
    const svg = $('[data-wp-line-svg]', sec), path = $('[data-wp-line-path]', sec), ghost = $('[data-wp-line-ghost]', sec), pencil = $('[data-wp-line-pencil]', sec);
    let len = 0;
    const build = () => {
      const r = sec.getBoundingClientRect();
      const anchors = $$('[data-wp-line-anchor]', sec).map(a => { const b = a.getBoundingClientRect(); return { x: b.left - r.left + b.width / 2, y: b.top - r.top + b.height / 2, w: b.width }; });
      if (anchors.length < 2) return;
      svg.setAttribute('viewBox', `0 0 ${r.width} ${r.height}`);
      const head = $('.wp-line__head', sec); const hb = head ? head.getBoundingClientRect().bottom - r.top + 30 : 0;
      const pts = [{ x: r.width * 0.5, y: hb }, ...anchors, { x: r.width * 0.5, y: r.height }];
      let d = `M${pts[0].x},${pts[0].y}`;
      for (let i = 1; i < pts.length; i++) {
        const p0 = pts[i - 1], p1 = pts[i];
        const sway = (i % 2 ? 1 : -1) * Math.min(r.width * 0.28, 260);
        const my = (p0.y + p1.y) / 2;
        d += ` C${p0.x + sway},${my - (p1.y - p0.y) * 0.2} ${p1.x - sway},${my + (p1.y - p0.y) * 0.2} ${p1.x},${p1.y}`;
        // small loop flourish mid-way
      }
      path.setAttribute('d', d); ghost.setAttribute('d', d);
      len = path.getTotalLength();
      path.style.strokeDasharray = `${len}`;
      draw();
    };
    const draw = () => {
      if (!len) return;
      const r = sec.getBoundingClientRect();
      const vh = window.innerHeight;
      let p = (vh * 0.6 - r.top) / r.height;
      p = reduce ? 1 : Math.max(0, Math.min(1, p));
      path.style.strokeDashoffset = `${len * (1 - p)}`;
      const pt = path.getPointAtLength(len * p);
      pencil.setAttribute('transform', `translate(${pt.x},${pt.y})`);
      pencil.style.opacity = p > 0.01 && p < 0.995 ? 1 : 0;
    };
    let ticking = false;
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { draw(); ticking = false; }); } }, { passive: true });
    let rt; window.addEventListener('resize', () => { clearTimeout(rt); rt = setTimeout(build, 150); });
    if (document.readyState === 'complete') build(); else window.addEventListener('load', build);
    setTimeout(build, 600);
    $$('img', sec).forEach(im => im.complete || im.addEventListener('load', build, { once: true }));
  });

  /* ---------- water reveal demo ---------- */
  $$('[data-wp-water]').forEach(w => {
    const box = $('.wp-water', w), dabs = $('[data-wp-water-dabs]', w); if (!box || !dabs) return;
    const svg = $('svg', box); const vb = svg.viewBox.baseVal;
    let down = false, last = 0;
    const dab = (e) => {
      const now = performance.now(); if (now - last < 16) return; last = now;
      const r = box.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * vb.width, y = ((e.clientY - r.top) / r.height) * vb.height;
      const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', x.toFixed(2)); c.setAttribute('cy', y.toFixed(2)); c.setAttribute('r', (5 + Math.random() * 3).toFixed(2)); c.setAttribute('fill', 'white');
      dabs.appendChild(c); box.classList.add('is-touched');
      setTimeout(() => { c.style.opacity = '0'; }, 1600);
      setTimeout(() => c.remove(), 4600);
      if (dabs.childNodes.length > 260) dabs.firstChild.remove();
    };
    box.addEventListener('pointerdown', e => { down = true; box.setPointerCapture && box.setPointerCapture(e.pointerId); dab(e); });
    box.addEventListener('pointermove', e => { if (down || e.pointerType === 'mouse') dab(e); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(t => box.addEventListener(t, () => { down = false; }));
  });

  /* ---------- cart ---------- */
  const drawer = $('[data-wp-drawer]');
  const countEls = () => $$('[data-wp-cart-count]');
  let lastFocus = null;
  async function getCart() { const r = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }); return r.json(); }
  function setCount(n) { countEls().forEach(el => { el.textContent = n; el.hidden = n === 0; }); $$('[data-wp-cart-open]').forEach(a => a.setAttribute('aria-label', `Cart, ${n} items`)); }
  function openDrawer() { if (!drawer) return; lastFocus = document.activeElement; drawer.hidden = false; document.documentElement.classList.add('wp-lock'); setTimeout(() => { const b = $('.wp-drawer__head button', drawer); b && b.focus(); }, 30); }
  function closeDrawer() { if (!drawer) return; drawer.hidden = true; document.documentElement.classList.remove('wp-lock'); lastFocus && lastFocus.focus && lastFocus.focus(); }
  async function renderCart(cart, status) {
    if (!drawer) return;
    cart = cart || await getCart();
    setCount(cart.item_count);
    const lines = $('[data-wp-drawer-lines]', drawer), empty = $('[data-wp-drawer-empty]', drawer), foot = $('[data-wp-drawer-foot]', drawer);
    $('[data-wp-drawer-count]', drawer).textContent = cart.item_count ? `(${cart.item_count})` : '';
    $('[data-wp-drawer-status]', drawer).innerHTML = status ? `<svg width="18" height="18" aria-hidden="true"><use href="#wp-i-spark"/></svg> ${esc(status)}` : '';
    empty.hidden = cart.item_count > 0; foot.hidden = cart.item_count === 0;
    lines.innerHTML = cart.items.map((it, i) => `
      <li class="wp-dl">
        <a href="${esc(it.url)}">${it.image ? `<img class="wp-dl__img" src="${esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, '$1$2'))}&width=200" alt="" width="84" height="84" loading="lazy">` : '<span class="wp-dl__img"></span>'}</a>
        <div>
          <a class="wp-dl__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${cleanVariant(it.variant_title) && !it.product_has_only_default_variant ? `<p class="wp-dl__variant">${esc(cleanVariant(it.variant_title))}</p>` : '<p class="wp-dl__variant"></p>'}
          ${(it.line_level_discount_allocations || []).map(d => `<p class="wp-dl__disc">${esc(d.discount_application.title)}</p>`).join('')}
          <div class="wp-miniqty"><button type="button" aria-label="Decrease quantity of ${esc(it.product_title)}" data-line="${i + 1}" data-q="${it.quantity - 1}"><svg aria-hidden="true"><use href="#wp-i-minus"/></svg></button><span aria-live="polite">${it.quantity}</span><button type="button" aria-label="Increase quantity of ${esc(it.product_title)}" data-line="${i + 1}" data-q="${it.quantity + 1}"><svg aria-hidden="true"><use href="#wp-i-plus"/></svg></button></div>
          <button type="button" class="wp-dl__rm" data-line="${i + 1}" data-q="0">Remove</button>
        </div>
        <div class="wp-dl__price">${it.original_line_price !== it.final_line_price ? `<s>${money(it.original_line_price)}</s>` : ''}${money(it.final_line_price)}</div>
      </li>`).join('');
    const disc = $('[data-wp-drawer-discounts]', drawer);
    disc.innerHTML = (cart.cart_level_discount_applications || []).map(d => `<p><span>${esc(d.title)}</span><span>−${money(d.total_allocated_amount)}</span></p>`).join('');
    $('[data-wp-drawer-subtotal]', drawer).textContent = money(cart.total_price);
    renderRecs(cart);
  }
  async function renderRecs(cart) {
    const box = $('[data-wp-drawer-recs]', drawer), list = $('[data-wp-drawer-recs-list]', drawer);
    if (!cart.items.length) { box.hidden = true; return; }
    try {
      const inCart = new Set(cart.items.map(i => i.product_id));
      const pid = cart.items[0].product_id;
      let r = await fetch(`${WP.routes.recs}.json?product_id=${pid}&limit=6&intent=complementary`);
      let d = await r.json(); let ps = (d.products || []);
      if (ps.length < 2) { r = await fetch(`${WP.routes.recs}.json?product_id=${pid}&limit=6&intent=related`); d = await r.json(); ps = ps.concat(d.products || []); }
      const seen = new Set();
      ps = ps.filter(p => p.available && !inCart.has(p.id) && !seen.has(p.id) && seen.add(p.id)).slice(0, 2);
      if (!ps.length) { box.hidden = true; return; }
      list.innerHTML = ps.map(p => {
        const single = p.variants.length === 1;
        return `<li class="wp-rec">${p.featured_image ? `<img src="${esc(p.featured_image)}&width=160" alt="" width="60" height="60" loading="lazy">` : '<span></span>'}<div><a href="${esc(p.url)}">${esc(p.title)}</a><span class="wp-rec__price">${p.price_varies ? 'From ' : ''}${money(p.price_min || p.price)}</span></div>${single ? `<button type="button" aria-label="Add ${esc(p.title)}" data-wp-quick-add="${p.variants[0].id}"><svg aria-hidden="true"><use href="#wp-i-plus"/></svg></button>` : `<a class="wp-rec__view" href="${esc(p.url)}" aria-label="Choose options for ${esc(p.title)}"><svg aria-hidden="true"><use href="#wp-i-arrow"/></svg></a>`}</li>`;
      }).join('');
      box.hidden = false;
    } catch (e) { box.hidden = true; }
  }
  async function addItems(items, label) {
    const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    const d = await r.json();
    if (!r.ok) throw new Error(d.description || d.message || 'Could not add to cart');
    document.dispatchEvent(new CustomEvent('cart:add', { detail: { items } }));
    $$('.wp-cartbtn').forEach(b => { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
    if (drawer) { await renderCart(null, label || 'Added to your cart'); openDrawer(); } else { window.location.href = WP.routes.cart; }
    return d;
  }
  async function changeLine(line, quantity) {
    const r = await fetch(`${root}cart/change.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    const cart = await r.json(); renderCart(cart);
  }
  if (drawer) {
    $$('[data-wp-cart-open]').forEach(a => a.addEventListener('click', e => { e.preventDefault(); renderCart(); openDrawer(); }));
    $$('[data-wp-cart-close]', drawer).forEach(b => b.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !drawer.hidden) closeDrawer(); });
    drawer.addEventListener('click', e => { const b = e.target.closest('[data-line]'); if (b) changeLine(+b.dataset.line, Math.max(0, +b.dataset.q)); });
  }
  // quick add (cards, recs)
  document.addEventListener('click', async e => {
    const b = e.target.closest('[data-wp-quick-add]'); if (!b) return;
    e.preventDefault(); b.classList.add('is-loading');
    try { await addItems([{ id: +b.dataset.wpQuickAdd, quantity: 1 }]); b.classList.add('is-added'); setTimeout(() => b.classList.remove('is-added'), 1600); }
    catch (err) { alert(err.message); }
    finally { b.classList.remove('is-loading'); }
  });

  /* ---------- product form ---------- */
  $$('[data-wp-product]').forEach(sec => {
    const form = $('[data-wp-product-form]', sec); if (!form) return;
    const variants = JSON.parse(($('[data-wp-variants]', sec.parentElement) || $('[data-wp-variants]')).textContent || '[]');
    const idInput = $('[data-wp-variant-id]', form), addBtn = $('[data-wp-add]', form), addLabel = $('[data-wp-add-label]', form);
    const priceBox = $('[data-wp-pdp-price]', sec), stock = $('[data-wp-stock]', sec);
    const fieldsets = $$('[data-wp-option]', form);
    const current = () => variants.find(v => String(v.id) === idInput.value) || variants[0];
    const selected = () => {
      const base = current() ? current().options.slice() : [];
      fieldsets.forEach(fs => { const i = +fs.dataset.wpOption; const c = $('input:checked', fs); if (c) base[i] = c.value; });
      return base;
    };
    const markAvailability = () => {
      const sel = selected();
      fieldsets.forEach(fs => {
        const i = +fs.dataset.wpOption;
        $$('.wp-pill', fs).forEach(p => {
          const val = $('input', p).value; const test = sel.slice(); test[i] = val;
          const v = variants.find(v => v.options.every((o, k) => o === test[k]));
          p.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    };
    const apply = (v) => {
      if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available; addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      priceBox.innerHTML = `<span class="wp-price">${v.compare_at_price > v.price ? `<s class="wp-price__was">${money(v.compare_at_price)}</s>` : ''}<span class="wp-price__now">${money(v.price)}</span></span>`;
      fieldsets.forEach(fs => { const cur = $('[data-wp-option-current]', fs); const c = $('input:checked', fs); if (cur && c) cur.textContent = c.value.replace(/Sytel/g, 'Style'); });
      if (stock && !stock.hasAttribute('hidden')) stock.textContent = '';
      if (v.featured_image && v.featured_image.src) swapImage(v.featured_image.src, v.featured_image.alt, v.featured_image.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      markAvailability();
    };
    fieldsets.forEach(fs => fs.addEventListener('change', () => {
      const sel = selected();
      apply(variants.find(v => v.options.every((o, k) => o === sel[k])));
    }));
    markAvailability();
    // qty
    $$('[data-wp-qty]', form).forEach(b => b.addEventListener('click', () => { const q = $('input[name="quantity"]', form); q.value = Math.max(1, (+q.value || 1) + (+b.dataset.wpQty)); }));
    form.addEventListener('submit', async e => {
      if (!drawer) return; e.preventDefault();
      addBtn.disabled = true; const prev = addLabel.textContent; addLabel.textContent = 'Adding…';
      try { await addItems([{ id: +idInput.value, quantity: Math.max(1, +$('input[name="quantity"]', form).value || 1) }]); }
      catch (err) { alert(err.message); }
      finally { addBtn.disabled = false; addLabel.textContent = prev; apply(current()); }
    });
    // gallery
    const main = $('[data-wp-gallery-main]', sec), thumbs = $$('[data-wp-thumb]', sec);
    function swapImage(src, alt, mediaId) {
      if (!main) return;
      const t = thumbs.find(t => mediaId && t.dataset.mediaId == mediaId) || thumbs.find(t => src && t.dataset.src.split('?')[0].split('_').slice(0, 1)[0] === src.split('?')[0].split('_').slice(0, 1)[0]);
      if (t) return showThumb(t);
    }
    function showThumb(t) {
      thumbs.forEach(x => x.classList.toggle('is-active', x === t));
      main.classList.add('is-swap');
      const img = new Image(); img.src = t.dataset.src;
      img.onload = () => { main.src = t.dataset.src; main.srcset = t.dataset.srcset; main.alt = t.dataset.alt; main.classList.remove('is-swap'); };
      t.scrollIntoView && t.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
    thumbs.forEach(t => t.addEventListener('click', () => showThumb(t)));
  });

  /* ---------- related products (section rendering) ---------- */
  $$('[data-wp-recs]').forEach(async el => {
    if (el.children.length) return;
    try { const r = await fetch(el.dataset.url); const html = await r.text(); const tmp = document.createElement('div'); tmp.innerHTML = html; const inner = tmp.querySelector('[data-wp-recs]'); if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; } catch (e) {}
  });

  /* ---------- sets ---------- */
  $$('[data-wp-set]').forEach(set => {
    const now = $('[data-wp-set-now]', set), was = $('[data-wp-set-was]', set), priceBox = $('[data-wp-set-price]', set);
    const pct = priceBox ? +priceBox.dataset.pct || 0 : 0;
    const inputs = () => $$('[data-wp-set-variant]', set);
    const priceOf = (el) => el.tagName === 'SELECT' ? +el.selectedOptions[0].dataset.price : +el.dataset.price;
    const recalc = () => {
      const total = inputs().reduce((s, el) => s + priceOf(el), 0);
      if (was) was.textContent = money(total);
      if (now) now.textContent = money(Math.round(total - (total * pct / 100)));
    };
    inputs().forEach(el => el.addEventListener('change', recalc));
    const btn = $('[data-wp-set-add]', set);
    btn && btn.addEventListener('click', async () => {
      btn.disabled = true;
      try { await addItems(inputs().map(el => ({ id: +el.value, quantity: 1 })), 'Your set is in your cart'); }
      catch (err) { alert(err.message); }
      finally { btn.disabled = false; }
    });
  });

  /* ---------- collection filters ---------- */
  $$('[data-wp-filter-form]').forEach(f => {
    f.addEventListener('change', () => {
      const params = new URLSearchParams(new FormData(f));
      window.location.search = params.toString();
    });
  });
})();
